<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot title="Video Library" />

        <div class="px-2 px-sm-4 px-md-12 mb-12 pb-12 mt-12">
            <v-row>
                <v-col cols="12">
                    <div class="title accent--text text-center">
                        Coming soon
                    </div>
                </v-col>
            </v-row>
        </div>

	</v-card>
</template>

<script>
export default {
    data: () => ({
        actual: 1
    }),
    mounted() {
        
    },
    methods: {
        
    }
}
</script>
